<div [ngClass]="containerClass" [ngStyle]="style" class="m-0 text-center">
    <fa-icon *ngIf="icon" [fixedWidth]="true" [icon]="icon"></fa-icon>
</div>
